import wizUploadFile from './index.vue'

wizUploadFile.install = (Vue) => {
  Vue.component(wizUploadFile.name, wizUploadFile)
}

export default wizUploadFile
